import React from "react";
import get from "lodash/get";

import { connectedFilterChip } from "./connectedFilterChip";

import { BoolChip } from "./Chips/BoolChip";
import { DateChip } from "./Chips/DateChip";
import { SelectChip } from "./Chips/SelectChip";
import { TextChip } from "./Chips/TextChip";
import { RangeChip } from "./Chips/RangeChip";
import { Pressable, Popover } from "~/native-ui";

const chipTypes = {
    text: { field: TextChip },
    select: { field: SelectChip },
    number: { field: RangeChip },
    select_many: { field: SelectChip, props: { multiSelect: true } },
    textarea: { field: TextChip, props: { multiline: true } },
    // wysiwyg: { field: TextField, props: { multiline: true } },
    wysiwyg: { field: TextChip, props: { multiline: true } },
    bool: { field: BoolChip },
    belongs_to: { field: SelectChip },
    belongs_to_many: { field: SelectChip, props: { multiSelect: true } },
    date: { field: DateChip, props: { } },
    datetime: { field: DateChip, },
    time: { field: DateChip, },
    file: { field: TextChip, },
    image: { field: TextChip },
};


const getChip = (type) => {
    return get(chipTypes, type) ?? chipTypes.text
}

export const FilterChip = connectedFilterChip(
    React.memo(
        React.forwardRef((props, ref) => {
            const {filter, filterValue, active, onPress, canDelete = active,} = props,
                {onDelete, trans} = props,
                {title, type} = filter,
                {field: Chip, props: chipProps} = getChip(type);

            const buttonProps = {
                ...chipProps,
                onPress,
                trans,
                title,
                active,
                filterValue,
                type,
                name: filter.name,
                variant: "outline",
                onDelete, canDelete,
                modelId: props.modelId,
                buttonProps: {
                    rounded: "full",
                }
            }

            return <Chip {...buttonProps} />
        })
    )
)

export const WithFilterChip = (Component) => React.memo((props) => {
    const { updateFilterOrder, onLayout,  ...filterProps } = props;
    const renderTrigger = ((triggerProps) => {
        return (
            <Pressable {...triggerProps}>
                <FilterChip name={props.name} modelId={props.modelId} {...triggerProps} />
            </Pressable>
        )
    })


    return (
        <Popover trigger={renderTrigger} onClose={updateFilterOrder}>
            <Popover.Content>
                <Popover.Arrow height={10} width={10} />
                <Popover.Body>
                    <Component autoApplyFilter={false} vertical { ...filterProps } defaultCreatedAt={0} />
                </Popover.Body>
            </Popover.Content>
        </Popover>
    )
});